module.exports = __webpack_public_path__ + "img/20191030174804048.5c95fb50.jpg";